/** code from https://github.com/angular/material2 */

import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { toBoolean } from '../util/convert';
import { NzTabComponent } from './nz-tab.component';
import { NzTabsNavComponent } from './nz-tabs-nav.component';

export interface NzAnimatedInterface {
  inkBar: boolean;
  tabPane: boolean;
}

export class NzTabChangeEvent {
  index: number;
  tab: NzTabComponent;
}

export type NzTabPosition = 'top' | 'bottom' | 'left' | 'right';
export type NzTabPositionMode = 'horizontal' | 'vertical';
export type NzTabType = 'line' | 'card';

@Component({
  selector     : 'nz-tabset',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <div [ngClass]="_classMap" #hostContent>
      <nz-tabs-nav
        #tabNav
        [nzSize]="nzSize"
        [nzType]="nzType"
        [nzShowPagination]="nzShowPagination"
        [nzPositionMode]="_tabPositionMode"
        [nzAnimated]="inkBarAnimated"
        [nzHideBar]="nzHide"
        [selectedIndex]="nzSelectedIndex">
        <ng-template #tabBarExtraContent>
          <ng-template [ngTemplateOutlet]="nzTabBarExtraTemplate || nzTabBarExtraContent"></ng-template>
        </ng-template>
        <div
          nz-tab-label
          [class.ant-tabs-tab-active]="(nzSelectedIndex == i)&&!nzHide"
          [disabled]="tab.disabled"
          (click)="clickLabel(i)"
          *ngFor="let tab of _tabs; let i = index">
          <ng-template [ngTemplateOutlet]="tab._tabHeading"></ng-template>
        </div>
      </nz-tabs-nav>
      <div class="ant-tabs-content"
        #tabContent
        [class.ant-tabs-content-animated]="tabPaneAnimated"
        [class.ant-tabs-content-no-animated]="!tabPaneAnimated"
        [style.margin-left.%]="tabPaneAnimated&&(-nzSelectedIndex*100)">
        <nz-tab-body
          class="ant-tabs-tabpane"
          [class.ant-tabs-tabpane-active]="(nzSelectedIndex == i)&&!nzHide"
          [class.ant-tabs-tabpane-inactive]="(nzSelectedIndex != i)||nzHide"
          [content]="tab.content"
          *ngFor="let tab of _tabs; let i = index">
        </nz-tab-body>
      </div>
    </div>`,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-container {
  height: 32px;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-ink-bar {
  visibility: hidden;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  margin: 0;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
  border-radius: 4px 4px 0 0;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  background: #f9f9f9;
  margin-right: 2px;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  padding: 5px 16px 4px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  background: #fff;
  border-color: #d9d9d9;
  color: #108ee9;
  padding-bottom: 5px;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-inactive {
  padding: 0;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-bottom: 0;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {
  color: rgba(0, 0, 0, 0.43);
  transition: all .3s;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  margin-right: 0;
  opacity: 0;
  position: absolute;
  right: 2px;
  top: 50%;
  margin-top: -5px;
  overflow: hidden;
  text-align: center;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  line-height: 1;
}
:root .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {
  filter: none;
}
:root .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close {
  font-size: 12px;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab .anticon-close:hover {
  color: rgba(0, 0, 0, 0.85);
}
.ant-tabs.ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane,
.ant-tabs.ant-tabs-editable-card .ant-tabs-content > .ant-tabs-tabpane {
  transition: none !important;
}
.ant-tabs.ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane-inactive,
.ant-tabs.ant-tabs-editable-card .ant-tabs-content > .ant-tabs-tabpane-inactive {
  overflow: hidden;
}
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:hover .anticon-close {
  opacity: 1;
}
.ant-tabs-extra-content {
  line-height: 32px;
}
.ant-tabs-extra-content .ant-tabs-new-tab {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  color: rgba(0, 0, 0, 0.43);
  transition: all .3s;
}
:root .ant-tabs-extra-content .ant-tabs-new-tab {
  filter: none;
}
:root .ant-tabs-extra-content .ant-tabs-new-tab {
  font-size: 12px;
}
.ant-tabs-extra-content .ant-tabs-new-tab:hover {
  color: #108ee9;
  border-color: #108ee9;
}
.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-nav-container {
  height: auto;
}
.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 8px;
}
.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  padding-bottom: 4px;
}
.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:last-child {
  margin-bottom: 8px;
}
.ant-tabs-vertical.ant-tabs-card > .ant-tabs-bar .ant-tabs-new-tab {
  width: 90%;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-right: 0;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab {
  border-right: 0;
  border-radius: 4px 0 0 4px;
  margin-right: 1px;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab-active {
  margin-right: -1px;
  padding-right: 18px;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-left: 0;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-right > .ant-tabs-bar .ant-tabs-tab {
  border-left: 0;
  border-radius: 0 4px 4px 0;
  margin-left: 1px;
}
.ant-tabs-vertical.ant-tabs-card.ant-tabs-right > .ant-tabs-bar .ant-tabs-tab-active {
  margin-left: -1px;
  padding-left: 18px;
}
.ant-tabs {
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  zoom: 1;
  color: rgba(0, 0, 0, 0.65);
}
.ant-tabs:before,
.ant-tabs:after {
  content: " ";
  display: table;
}
.ant-tabs:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-tabs-ink-bar {
  z-index: 1;
  position: absolute;
  left: 0;
  bottom: 1px;
  box-sizing: border-box;
  height: 2px;
  background-color: #108ee9;
  transform-origin: 0 0;
}
.ant-tabs-bar {
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 16px;
  outline: none;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-nav-container {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
  box-sizing: border-box;
  position: relative;
  white-space: nowrap;
  margin-bottom: -1px;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  zoom: 1;
}
.ant-tabs-nav-container:before,
.ant-tabs-nav-container:after {
  content: " ";
  display: table;
}
.ant-tabs-nav-container:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-tabs-nav-container-scrolling {
  padding-left: 32px;
  padding-right: 32px;
}
.ant-tabs-tab-prev,
.ant-tabs-tab-next {
  user-select: none;
  z-index: 2;
  width: 0;
  height: 100%;
  line-height: 32px;
  cursor: pointer;
  border: 0;
  background-color: transparent;
  position: absolute;
  text-align: center;
  color: rgba(0, 0, 0, 0.43);
  transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  opacity: 0;
  pointer-events: none;
}
.ant-tabs-tab-prev.ant-tabs-tab-arrow-show,
.ant-tabs-tab-next.ant-tabs-tab-arrow-show {
  opacity: 1;
  width: 32px;
  height: 100%;
  pointer-events: auto;
}
.ant-tabs-tab-prev:hover,
.ant-tabs-tab-next:hover {
  color: rgba(0, 0, 0, 0.65);
}
.ant-tabs-tab-prev-icon,
.ant-tabs-tab-next-icon {
  font-style: normal;
  font-weight: bold;
  font-variant: normal;
  line-height: inherit;
  vertical-align: baseline;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  text-transform: none;
}
.ant-tabs-tab-prev-icon:before,
.ant-tabs-tab-next-icon:before {
  display: block;
  font-family: "anticon" !important;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
}
:root .ant-tabs-tab-prev-icon:before,
:root .ant-tabs-tab-next-icon:before {
  filter: none;
}
:root .ant-tabs-tab-prev-icon:before,
:root .ant-tabs-tab-next-icon:before {
  font-size: 12px;
}
.ant-tabs-tab-btn-disabled {
  cursor: not-allowed;
}
.ant-tabs-tab-btn-disabled,
.ant-tabs-tab-btn-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
}
.ant-tabs-tab-next {
  right: 2px;
}
.ant-tabs-tab-next-icon:before {
  content: "\\e61f";
}
.ant-tabs-tab-prev {
  left: 0;
}
.ant-tabs-tab-prev-icon:before {
  content: "\\e620";
}
:root .ant-tabs-tab-prev {
  filter: none;
}
.ant-tabs-nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
}
.ant-tabs-nav-scroll {
  overflow: hidden;
  white-space: nowrap;
}
.ant-tabs-nav {
  box-sizing: border-box;
  padding-left: 0;
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  position: relative;
  margin: 0;
  list-style: none;
  display: inline-block;
}
.ant-tabs-nav:before,
.ant-tabs-nav:after {
  display: table;
  content: " ";
}
.ant-tabs-nav:after {
  clear: both;
}
.ant-tabs-nav .ant-tabs-tab-disabled {
  pointer-events: none;
  cursor: default;
  color: rgba(0, 0, 0, 0.25);
}
.ant-tabs-nav .ant-tabs-tab {
  display: inline-block;
  height: 100%;
  margin-right: 24px;
  box-sizing: border-box;
  position: relative;
  padding: 8px 20px;
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  cursor: pointer;
  text-decoration: none;
}
.ant-tabs-nav .ant-tabs-tab:last-child {
  margin-right: 0;
}
.ant-tabs-nav .ant-tabs-tab:hover {
  color: #49a9ee;
}
.ant-tabs-nav .ant-tabs-tab:active {
  color: #0e77ca;
}
.ant-tabs-nav .ant-tabs-tab .anticon {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}
.ant-tabs-nav .ant-tabs-tab-active {
  color: #108ee9;
}
.ant-tabs-mini .ant-tabs-nav-container {
  font-size: 12px;
}
.ant-tabs-mini .ant-tabs-tab {
  margin-right: 0;
  padding: 8px 16px;
}
.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content {
  width: 100%;
}
.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content > .ant-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity .45s;
  opacity: 1;
}
.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content > .ant-tabs-tabpane-inactive {
  opacity: 0;
  height: 0;
  padding: 0 !important;
  pointer-events: none;
}
.ant-tabs:not(.ant-tabs-vertical) > .ant-tabs-content-animated {
  display: flex;
  flex-direction: row;
  will-change: margin-left;
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-vertical > .ant-tabs-bar {
  border-bottom: 0;
  height: 100%;
}
.ant-tabs-vertical > .ant-tabs-bar-tab-prev,
.ant-tabs-vertical > .ant-tabs-bar-tab-next {
  width: 32px;
  height: 0;
  transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-vertical > .ant-tabs-bar-tab-prev.ant-tabs-tab-arrow-show,
.ant-tabs-vertical > .ant-tabs-bar-tab-next.ant-tabs-tab-arrow-show {
  width: 100%;
  height: 32px;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab {
  float: none;
  margin-right: 0;
  margin-bottom: 16px;
  display: block;
  padding: 8px 24px;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab:last-child {
  margin-bottom: 0;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-extra-content {
  text-align: center;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-scroll {
  width: auto;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container,
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-wrap {
  height: 100%;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container {
  margin-bottom: 0;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-container.ant-tabs-nav-container-scrolling {
  padding: 32px 0;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-bottom: 0;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-nav {
  width: 100%;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-ink-bar {
  width: 2px;
  left: auto;
  height: auto;
  top: 0;
}
.ant-tabs-vertical > .ant-tabs-content {
  overflow: hidden;
  width: auto;
  margin-top: 0 !important;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-next {
  width: 100%;
  bottom: 0;
  height: 32px;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-next-icon:before {
  content: "\\e61d";
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-prev {
  top: 0;
  width: 100%;
  height: 32px;
}
.ant-tabs-vertical > .ant-tabs-bar .ant-tabs-tab-prev-icon:before {
  content: "\\e61e";
}
.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar {
  float: left;
  border-right: 1px solid #e9e9e9;
  margin-right: -1px;
  margin-bottom: 0;
}
.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab {
  text-align: right;
}
.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-container {
  margin-right: -1px;
}
.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-right: -1px;
}
.ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-ink-bar {
  right: 1px;
}
.ant-tabs-vertical.ant-tabs-left > .ant-tabs-content {
  padding-left: 24px;
  border-left: 1px solid #e9e9e9;
}
.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar {
  float: right;
  border-left: 1px solid #e9e9e9;
  margin-left: -1px;
  margin-bottom: 0;
}
.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-container {
  margin-left: -1px;
}
.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-nav-wrap {
  margin-left: -1px;
}
.ant-tabs-vertical.ant-tabs-right > .ant-tabs-bar .ant-tabs-ink-bar {
  left: 1px;
}
.ant-tabs-vertical.ant-tabs-right > .ant-tabs-content {
  padding-right: 24px;
  border-right: 1px solid #e9e9e9;
}
.ant-tabs-bottom > .ant-tabs-bar {
  margin-bottom: 0;
  margin-top: 16px;
}
.ant-tabs-top .ant-tabs-ink-bar-animated,
.ant-tabs-bottom .ant-tabs-ink-bar-animated {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-tabs-left .ant-tabs-ink-bar-animated,
.ant-tabs-right .ant-tabs-ink-bar-animated {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.no-flex > .ant-tabs-content-animated,
.ant-tabs-no-animation > .ant-tabs-content-animated,
.ant-tabs-vertical > .ant-tabs-content-animated {
  transform: none !important;
  margin-left: 0 !important;
}
.no-flex > .ant-tabs-content > .ant-tabs-tabpane-inactive,
.ant-tabs-no-animation > .ant-tabs-content > .ant-tabs-tabpane-inactive,
.ant-tabs-vertical > .ant-tabs-content > .ant-tabs-tabpane-inactive {
  display: none;
}
`,
    `nz-tab {
  display: block;
}
nz-tabs-nav {
  display: block;
}
nz-tabset {
  display: block;
  position: relative;
  overflow: hidden;
}
nz-tabset .ant-tabs {
  height: 100%;
}
nz-tab-body {
  display: block;
}
`
  ]
})
export class NzTabSetComponent implements AfterContentChecked, OnInit, AfterViewInit {
  _el;
  _classMap;
  _prefixCls = 'ant-tabs';
  _width;
  _tabPosition: NzTabPosition = 'top';
  _tabPositionMode: NzTabPositionMode = 'horizontal';
  _indexToSelect: number | null = 0;
  _selectedIndex: number | null = null;
  _isViewInit = false;
  _tabs: NzTabComponent[] = [];
  @Input() nzTabBarExtraTemplate: TemplateRef<void>;
  @ContentChild('nzTabBarExtraContent') nzTabBarExtraContent: TemplateRef<void>;
  @ViewChild('tabNav') _tabNav: NzTabsNavComponent;
  @ViewChild('tabContent') _tabContent: ElementRef;
  @ViewChild('hostContent') _hostContent: ElementRef;
  @Input() nzAnimated: NzAnimatedInterface | boolean = true;
  @Input() nzShowPagination = true;
  @Input() nzHide = false;

  @Input()
  set nzSelectedIndex(value: number | null) {
    this._indexToSelect = value;
  }

  get nzSelectedIndex(): number | null {
    return this._selectedIndex;
  }

  @Output()
  get nzSelectedIndexChange(): Observable<number> {
    return this.nzSelectChange.pipe(map(event => event.index));
  }

  @Output() nzSelectChange: EventEmitter<NzTabChangeEvent> = new EventEmitter<NzTabChangeEvent>(true);

  @Input() nzSize = 'default';
  _type: NzTabType = 'line';
  tabs: NzTabComponent[] = [];

  @Input()
  set nzTabPosition(value: NzTabPosition) {
    if (this._tabPosition === value) {
      return;
    }
    this._tabPosition = value;
    if ((this._tabPosition === 'top') || (this._tabPosition === 'bottom')) {
      this._tabPositionMode = 'horizontal';
    } else {
      this._tabPositionMode = 'vertical';
    }
    this._setPosition(value);
    this._setClassMap();
  }

  get nzTabPosition(): NzTabPosition {
    return this._tabPosition;
  }

  @Input()
  set nzType(value: NzTabType) {
    if (this._type === value) {
      return;
    }
    this._type = value;
    if (this._type === 'card') {
      this.nzAnimated = false;
    }
    this._setClassMap();
  }

  get nzType(): NzTabType {
    return this._type;
  }

  _setPosition(value: NzTabPosition): void {
    if (this._isViewInit) {
      if (value === 'bottom') {
        this._renderer.insertBefore(this._hostContent.nativeElement, this._tabContent.nativeElement, this._tabNav._elementRef.nativeElement);
      } else {
        this._renderer.insertBefore(this._hostContent.nativeElement, this._tabNav._elementRef.nativeElement, this._tabContent.nativeElement);
      }
    }

  }

  _setClassMap(): void {
    this._classMap = {
      [this._prefixCls]                          : true,
      [`${this._prefixCls}-vertical`]            : (this._tabPosition === 'left') || (this._tabPosition === 'right'),
      [`${this._prefixCls}-${this._tabPosition}`]: this._tabPosition,
      [`${this._prefixCls}-no-animation`]        : (this.nzAnimated === false) || ((this.nzAnimated as NzAnimatedInterface).tabPane === false),
      [`${this._prefixCls}-${this._type}`]       : this._type,
      [`${this._prefixCls}-mini`]                : (this.nzSize === 'small')
    };
  }

  clickLabel(index: number): void {
    this.nzSelectedIndex = index;
    this._tabs[ index ].nzClick.emit();
  }

  ngOnInit(): void {
    this._setClassMap();
  }

  ngAfterContentChecked(): void {
    // Clamp the next selected index to the bounds of 0 and the tabs length. Note the `|| 0`, which
    // ensures that values like NaN can't get through and which would otherwise throw the
    // component into an infinite loop (since Math.max(NaN, 0) === NaN).
    const indexToSelect = this._indexToSelect =
      Math.min(this._tabs.length - 1, Math.max(this._indexToSelect || 0, 0));

    // If there is a change in selected index, emit a change event. Should not trigger if
    // the selected index has not yet been initialized.
    if (this._selectedIndex !== indexToSelect && this._selectedIndex != null) {
      this.nzSelectChange.emit(this._createChangeEvent(indexToSelect));
    }

    // Setup the position for each tab and optionally setup an origin on the next selected tab.
    this._tabs.forEach((tab: NzTabComponent, index: number) => {
      tab.position = index - indexToSelect;
      // If there is already a selected tab, then set up an origin for the next selected tab
      // if it doesn't have one already.
      if (this._selectedIndex != null && tab.position === 0 && !tab.origin) {
        tab.origin = indexToSelect - this._selectedIndex;
      }
    });
    this._selectedIndex = indexToSelect;
  }

  ngAfterViewInit(): void {
    this._isViewInit = true;
    this._setPosition(this._tabPosition);
  }

  private _createChangeEvent(index: number): NzTabChangeEvent {
    const event = new NzTabChangeEvent();
    event.index = index;
    if (this._tabs && this._tabs.length) {
      event.tab = this._tabs[ index ];
      this._tabs.forEach((item, i) => {
        if (i !== index) {
          item.nzDeselect.emit();
        }
      });
      event.tab.nzSelect.emit();
    }
    return event;
  }

  get inkBarAnimated(): boolean {
    return (this.nzAnimated === true) || ((this.nzAnimated as NzAnimatedInterface).inkBar === true);
  }

  get tabPaneAnimated(): boolean {
    return (this.nzAnimated === true) || ((this.nzAnimated as NzAnimatedInterface).tabPane === true);
  }

  constructor(private _renderer: Renderer2) {
  }
}
